export default (arr) => arr.reduce((accumulator, value) => ({...accumulator, [value]: value}), {});



// WEBPACK FOOTER //
// ./src/misc/toMap.js